// Result-screen confetti burst, drawn on the fixed `#confetti-canvas` overlay.

interface Particle {
  x: number;
  y: number;
  w: number;
  h: number;
  color: string;
  speed: number;
  angle: number;
  spin: number;
  drift: number;
}

export function shootConfetti(): void {
  const canvas = document.getElementById('confetti-canvas') as HTMLCanvasElement | null;
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  const colors = ['#8b5cf6', '#ec4899', '#22c55e', '#f59e0b', '#06b6d4', '#ef4444'];
  const particles: Particle[] = [];

  for (let i = 0; i < 80; i++) {
    particles.push({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height - canvas.height,
      w: Math.random() * 10 + 5,
      h: Math.random() * 6 + 3,
      color: colors[Math.floor(Math.random() * colors.length)],
      speed: Math.random() * 3 + 2,
      angle: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.1,
      drift: (Math.random() - 0.5) * 2,
    });
  }

  let frame = 0;
  function animate() {
    ctx!.clearRect(0, 0, canvas!.width, canvas!.height);
    let alive = false;
    for (const p of particles) {
      p.y += p.speed;
      p.x += p.drift;
      p.angle += p.spin;
      if (p.y < canvas!.height + 20) alive = true;
      ctx!.save();
      ctx!.translate(p.x, p.y);
      ctx!.rotate(p.angle);
      ctx!.fillStyle = p.color;
      ctx!.globalAlpha = Math.max(0, 1 - p.y / canvas!.height);
      ctx!.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx!.restore();
    }
    frame++;
    if (alive && frame < 300) requestAnimationFrame(animate);
    else ctx!.clearRect(0, 0, canvas!.width, canvas!.height);
  }
  animate();
}

declare global {
  interface Window {
    shootConfetti: typeof shootConfetti;
  }
}

// Exposed on window: the legacy inline script (index.html) calls this as a
// bare global (`shootConfetti()`) after a round/game finishes.
window.shootConfetti = shootConfetti;
